import BasicDetail from './components/BasicDetail';
import CardInformation from './components/CardInformation';
import ConditionAfterDetail from '../components/form-sections/ConditionAfterDetail';
import ConditionCheckDetail from '../components/form-sections/ConditionCheckDetail';
import ConditionPassiveDetail from '../components/form-sections/ConditionPassiveDetail';
import ConditionSuccessFailureDetail from '../components/form-sections/ConditionSuccessFailureDetail';
import DvComparedDetail from '../components/form-sections/DvComparedDetail';
import MiscellaneousDetail from '../components/form-sections/MiscellaneousDetail';
import PromptDetail from '../components/form-sections/PromptDetail';
import StatusDetail from '../components/form-sections/StatusDetail';
import CardTransformedDetail from '../components/form-sections/CardTransformedDetail';
import TypeDetail from '../components/form-sections/TypeDetail';
import RewardPenaltyDetail from '../components/form-sections/RewardPenaltyDetail';
import RestrictionDetail from '../components/form-sections/RestrictionDetail';

export const FORM_GROUPS = [
    {
        name: 'CardInformation',
        component: CardInformation,
    },
    {
        name: 'BasicDetail',
        component: BasicDetail,
    },
    {
        name: 'StatusDetail',
        component: StatusDetail,
    },
    {
        name: 'CardTransformedDetail',
        component: CardTransformedDetail,
    },
    {
        name: 'DvComparedDetail',
        component: DvComparedDetail,
    },
    {
        name: 'TypeDetail',
        component: TypeDetail,
    },
    {
        name: 'RewardPenaltyDetail',
        component: RewardPenaltyDetail,
    },
    {
        name: 'ConditionCheckDetail',
        component: ConditionCheckDetail,
    },
    {
        name: 'ConditionSuccessFailureDetail',
        component: ConditionSuccessFailureDetail,
    },
    {
        name: 'ConditionAfterDetail',
        component: ConditionAfterDetail,
    },
    {
        name: 'ConditionPassiveDetail',
        component: ConditionPassiveDetail,
    },
    {
        name: 'PromptDetail',
        component: PromptDetail,
    },
    {
        name: 'RestrictionDetail',
        component: RestrictionDetail,
    },
    {
        name: 'MiscellaneousDetail',
        component: MiscellaneousDetail,
    },
];
